import { SortDirection } from 'interfaces'
import { getObjectProperty } from './getObjectProperty'

export const sortByObjectProperty = <T>(
  arr: Array<T>,
  path: string,
  dir: SortDirection,
): Array<T> => {
  return arr?.sort((a, b) => {
    const aValue = getObjectProperty(a, path)
    const bValue = getObjectProperty(b, path)

    if (typeof aValue === 'number' && typeof bValue === 'number') {
      return dir === SortDirection.ASC ? aValue - bValue : bValue - aValue
    }

    if (!isNaN(Number(aValue)) && !isNaN(Number(bValue))) {
      return dir === SortDirection.ASC
        ? Number(aValue) - Number(bValue)
        : Number(bValue) - Number(aValue)
    }

    if (typeof aValue === 'string' && typeof bValue === 'string') {
      return dir === SortDirection.ASC
        ? bValue?.localeCompare(aValue)
        : aValue?.localeCompare(bValue)
    }

    return 0
  })
}
